<template>
  <v-container fluid class="pa-0 fill-height mo-bg">
    <v-row align="center" justify="center" class="ma-0 pa-0 fill-height">
      <v-col
        cols="12"
        sm="10"
        md="8"
        lg="6"
        class="fill-height d-flex align-center"
      >
        <v-sheet
          elevation="3"
          rounded
          class="mx-auto mo-panel"
          max-width="640"
          style="width: 100%; max-height: 90vh; overflow: hidden"
        >
          <v-toolbar flat dense class="mo-toolbar">
            <v-btn icon small class="white--text mr-1" @click="goBack">
              <v-icon color="white" small>mdi-arrow-left</v-icon>
            </v-btn>
            <v-toolbar-title class="white--text d-flex align-center">
              <v-icon left small color="white" class="mr-2"
                >mdi-clipboard-text-outline</v-icon
              >
              Formulir Passed Produksi
            </v-toolbar-title>
            <v-spacer></v-spacer>
          </v-toolbar>
          <div class="pa-5 pt-6">
            <v-form
              @submit.prevent="searchMO"
              ref="formPassedProduction"
              lazy-validation
            >
              <v-row dense>
                <v-col cols="12">
                  <v-select
                    v-model="form.mesin"
                    :items="dropdown.mesin"
                    :rules="rules.mesinRules"
                    item-text="name"
                    item-value="id"
                    label="Mesin"
                    return-object
                    outlined
                    dense
                    @change="onMesinChange"
                  />
                </v-col>

                <v-col cols="12">
                  <v-select
                    v-model="form.sku"
                    :items="dropdown.sku"
                    :disabled="!form.mesin"
                    :rules="rules.skuRules"
                    label="Produk"
                    item-text="name"
                    item-value="id"
                    return-object
                    outlined
                    dense
                    @change="onProductChange"
                  />
                </v-col>

                <v-col cols="12" md="6">
                  <v-select
                    v-model="form.shift"
                    :items="dropdown.shift"
                    :rules="rules.shiftRules"
                    label="Shift"
                    item-text="name"
                    item-value="id"
                    return-object
                    outlined
                    dense
                  />
                </v-col>
                <v-col cols="12" md="6">
                  <v-text-field
                    v-model="form.date"
                    :rules="rules.dateRules"
                    dense
                    label="Tanggal"
                    type="date"
                    name="startdate"
                    step="1"
                    outlined
                    clearable
                  />
                </v-col>
                <!-- <v-col cols="12" md="6">
                <v-select
                  v-model="form.jmlSusunan"
                  :items="dropdown.jenisSusunan"
                  :disabled="!form.sku"
                  @change="onLayerChange"
                  :rules="rules.susunanRules"
                  label="Susunan pallet"
                  item-text="name"
                  item-value="id"
                  return-object
                  outlined
                  dense
                />
              </v-col>

              <v-col cols="12" md="6">
                <v-text-field
                  v-model.number="form.total_qty_in_pallet"
                  :rules="rules.totalDusRules"
                  label="Total Dus di Pallet"
                  type="number"
                  outlined
                  disabled
                  dense
                />
              </v-col>
              <v-col cols="12" md="6">
                <v-text-field
                  v-model.number="form.qtyPrint"
                  :rules="rules.qtyPrint"
                  label="Qty Print"
                  type="number"
                  outlined
                  dense
                />
              </v-col> -->
              </v-row>
              <v-row justify="center" class="mt-4">
                <v-btn
                  type="submit"
                  class="mo-primary-outline"
                  large
                  elevation="0"
                  style="width: 100%"
                >
                  <v-icon left>mdi-magnify</v-icon>
                  Cari MO Yang Sudah Terbentuk
                </v-btn>
              </v-row>
            </v-form>
            <!-- <v-row justify="center" class="mt-4">
            <v-btn
              color="primary"
              large
              elevation="2"
              @click="submitForm"
              style="width: 100%"
            >
              <v-icon left>mdi-printer</v-icon>
              Print
            </v-btn>
          </v-row> -->
          </div>
        </v-sheet>
      </v-col>
    </v-row>
    <MoListDialog
      :moListData="moListData"
      @openDetailMO="openDetailMO"
      @select-mo="openDetailMO"
    />
    <div style="position: fixed; bottom: 10px; right: 0; z-index: 3">
      <Scanner />
    </div>
  </v-container>
</template>

<script>
import axios from 'axios'
import buildType from '../../../services/buildType'
import { mapGetters } from 'vuex'
import MoListDialog from './components/manufactureList'
import Scanner from '../../home/components/Scanner.vue'
export default {
  components: {
    MoListDialog,
    Scanner
  },
  data() {
    return {
      build: process.env.VUE_APP_BUILD_TYPE,
      odooApi: buildType.apiURL('odoo'),
      form: {
        mesin: null,
        sku: null,
        shift: null,
        jmlSusunan: null,
        qtyPrint: null,
        date: null
      },
      mesinList: ['Mesin A', 'Mesin B'],
      skuData: {
        'Mesin A': ['SKU-A1', 'SKU-A2'],
        'Mesin B': ['SKU-B1', 'SKU-B2']
      },
      susunanOptions: [
        {
          label: '13 x 8 (13 ke atas, 8 ke samping)',
          value: { rows: 13, columns: 8 }
        },
        {
          label: '12 x 6 (12 ke atas, 6 ke samping)',
          value: { rows: 12, columns: 6 }
        },
        {
          label: '10 x 10 (10 ke atas, 10 ke samping)',
          value: { rows: 10, columns: 10 }
        }
      ],
      dropdown: {
        mesin: [],
        mesinInfo: [],
        sku: [],
        shift: [],
        jenisSusunan: []
      },
      rules: {
        mesinRules: [],
        skuRules: [],
        shiftRules: [],
        dateRules: [],
        susunanRules: [],
        totalDusRules: [],
        qtyPrintRules: []
      },
      moListData: []
    }
  },
  computed: {
    ...mapGetters(['getUserProfile'])
  },
  mounted() {
    this.form.date = new Date().toISOString().split('T')[0]
    this.dropdownMesin()
    this.dropdownShift()
  },
  methods: {
    goBack() {
      this.$router && this.$router.push({ name: 'manufactureDashboard' })
    },
    showMsgDialog(pModalType, pStatusMsg, pBtnCancel, pInputType, pInputAtt) {
      const title =
        pInputType === 'file'
          ? 'Upload bukti approvement pada kolom dibawah'
          : ''
      return new Promise((resolve) => {
        this.$swal
          .fire({
            position: 'center',
            icon: pModalType,
            html: '<strong style="font-size:18px;">' + pStatusMsg + '</strong>',
            // html: pStatusMsg,
            showConfirmButton: true,
            showCancelButton: pBtnCancel,
            cancelButtonText: 'No',
            input: pInputType !== undefined ? pInputType : null,
            inputLabel: pInputType !== undefined ? title : null,
            inputAttributes: pInputAtt !== undefined ? pInputAtt : null
          })
          .then((r) => {
            resolve(r)
          })
      })
    },
    onMesinChange(val) {
      console.log(val)
      if (val != null) {
        this.dropdownMesinInfo(val)
      } else {
        this.dropdown.mesinInfo = []
      }
    },
    onProductChange(val) {
      console.log(val)
      if (val != null) {
        this.dropdown.jenisSusunan = val.pallet
      } else {
        this.dropdown.jenisSusunan = []
      }
    },
    onLayerChange(val) {
      console.log(val)
      if (val != null) {
        if (
          val.palletizer_qty_per_layer != null &&
          val.palletizer_total_layer != null
        ) {
          this.form.total_qty_in_pallet =
            val.palletizer_qty_per_layer * val.palletizer_total_layer
        }
      } else {
        this.form.total_qty_in_pallet = null
      }
    },
    submitForm() {
      const self = this
      this.rules.mesinRules = [(v) => !!v || 'Kolom mesin wajib diisi']
      this.rules.skuRules = [(v) => !!v || 'Kolom SKU wajib diisi']
      this.rules.shiftRules = [(v) => !!v || 'Kolom shift wajib diisi']
      this.rules.susunanRules = [(v) => !!v || 'Kolom susunan wajib diisi']
      this.rules.totalDusRules = [(v) => !!v || 'Kolom isi dus wajib diisi']
      this.rules.qtyPrintRules = [(v) => !!v || 'Kolom qty print wajib diisi']
      setTimeout(function () {
        if (self.$refs.form.validate()) {
          const xForm = {
            machine_id: self.form.mesin.id,
            product_id: self.form.sku.id,
            shift_id: self.form.shift.id,
            total_qty_in_pallet: self.form.total_qty_in_pallet,
            qty_print: self.form.qtyPrint,
            date: self.form.date
          }
          console.log('xForm >>>>', xForm)
          axios
            .post(`${self.odooApi}print_thermal/passet`, xForm)
            .then((res) => {
              if (res.data.status_code == '00') {
                self.showMsgDialog('success', res.data.status_msg, false)
              } else {
                self.showMsgDialog('error', res.data.status_msg, false)
              }
              self.loading = false
            })
            .catch((err) => {
              console.log(err)
              self.loading = false
            })
        }
      })
    },
    dropdownMesin() {
      this.dropdown.mesin = []
      let url = `${this.odooApi}master/universal/mrp_mesin/dropdown`

      // Bangun objek filter
      const filter = []
      if (
        this.getUserProfile.employee != null &&
        this.getUserProfile.employee.company != null
      ) {
        filter.push({
          '$company.code_plant$': this.getUserProfile.employee.company.plant_id
        })
      }

      // Bangun join_table sebagai array objek
      const join_table = [{ name: 'res_company', alias: 'company' }]

      // Buat query param dengan encodeURIComponent + JSON.stringify
      const filterStr = encodeURIComponent(JSON.stringify(filter))
      const joinTableStr = encodeURIComponent(JSON.stringify(join_table))

      // Gabungkan URL dengan param terencode dan urutan param filter dulu join_table kemudian
      url = `${url}?filter=${filterStr}&join_table=${joinTableStr}`

      axios
        .get(url)
        .then((res) => {
          this.dropdown.mesin = res.data.data
        })
        .catch((err) => {
          console.log(err)
        })
    },
    dropdownShift() {
      this.dropdown.shift = []
      let url = `${this.odooApi}master/universal/v_mrp_shift/dropdown?`

      const filter = []
      // &status=${this.paramAPI.status}
      if (
        this.getUserProfile.employee != null &&
        this.getUserProfile.employee.company != null
      ) {
        filter.push(
          `{"company_id":${this.getUserProfile.employee.company.plant_id}}`
        )
      }
      url = url + `filter=[${filter}]`
      axios
        .get(url)
        .then((res) => {
          this.dropdown.shift = res.data.data
        })
        .catch((err) => {
          console.log(err)
        })
    },
    dropdownMesinInfo() {
      // this.dropdown.shift = []
      let url = `${this.odooApi}master/universal/mrp_mesin_information/dropdown`

      const filter = []
      // &status=${this.paramAPI.status}
      if (this.form.mesin != null) {
        filter.push(`{"mesin_id":${this.form.mesin.id}}`)
      }
      url = url + `?filter=[${filter}]`
      url =
        url +
        '&join_table=[{"name":"v_product_product_product_template","alias":"product"},{"name":"palletizer_layer","alias":"palletizer_layer"}]'
      axios
        .get(url)
        .then((res) => {
          if (res.data.status_code == '00') {
            this.dropdown.mesinInfo = res.data.data
            const product = []
            for (let i = 0; i < res.data.data.length; i++) {
              product.push({
                id: res.data.data[i].product.product_id,
                name: res.data.data[i].product.name,
                code: res.data.data[i].product.product_code,
                template_id: res.data.data[i].product.product_template_id,
                pallet: res.data.data[i].pallet_layer
              })
            }
            console.log('dropdown.sku >>>>', product)

            this.dropdown.sku = product
          } else {
            this.dropdown.sku = []
          }
        })
        .catch((err) => {
          console.log(err)
          this.dropdown.sku = []
        })
    },
    searchMO() {
      const self = this
      this.rules.mesinRules = [(v) => !!v || 'Mesin is required']
      this.rules.skuRules = [(v) => !!v || 'Product is required']
      this.rules.shiftRules = [(v) => !!v || 'Shift is required']
      this.rules.dateRules = [(v) => !!v || 'Date is required']

      setTimeout(function () {
        if (self.$refs.formPassedProduction.validate()) {
          self.searchNow()
        }
      })
    },
    searchNow() {
      console.log('form>>>', this.form)
      const plantId = this.getUserProfile.employee.company.plant_id
      const mesinId = this.form.mesin != null ? this.form.mesin.id : null
      const productId = this.form.sku != null ? this.form.sku.id : null
      const shiftId = this.form.shift != null ? this.form.shift.id : null
      const date = this.form.date
      const url = `${this.odooApi}manufacture/list?plant_id=${plantId}&mesin_id=${mesinId}&product_id=${productId}&shift_id=${shiftId}&date=${date}`
      console.log('url>>>', url)
      axios
        .get(url)
        .then((res) => {
          console.log('manufacture>>>', res)
          if (res.data.status_code == '00') {
            if (res.data.data.length > 0) {
              this.moListData = res.data.data
              setTimeout(() => {
                document.getElementById('manufactureListId').click()
              }, 300)
            } else {
              this.showMsgDialog('info', 'Data tidak tersedia', false)
            }
          } else {
            if (res.data.status_msg == 'Data not found') {
              this.showMsgDialog('warning', 'Data tidak tersedia', false)
            } else {
              this.showMsgDialog('warning', res.data.status_msg, false)
            }
          }
        })
        .catch((err) => {
          console.log(err)
        })
    },
    openDetailMO(item) {
      console.log('Selected MO:', item)
      this.$router.push({ name: 'manufactureDetail', query: { id: item.id } })
    }
  }
}
</script>

<style scoped>
.fill-height {
  height: 87vh;
  overflow: hidden;
}

/* Soft background to match dialog */
.mo-bg {
  background: linear-gradient(180deg, #fafcff 0%, #ffffff 70%);
}

/* Top toolbar gradient (match dialog) */
.mo-toolbar {
  background: linear-gradient(135deg, #90caf9 0%, #a5d6a7 100%);
}

/* Panel card styling */
.mo-panel {
  background-color: #fff;
  border-radius: 16px;
}

/* Primary action button outlined/shadowed */
.mo-primary-outline {
  background: #fff !important;
  color: #1e88e5 !important; /* primary-ish text */
  border: 1.5px solid #64b5f6 !important;
  border-radius: 10px;
  box-shadow: 0 3px 12px rgba(100, 181, 246, 0.25),
    0 1px 2px rgba(0, 0, 0, 0.04) !important;
  text-transform: none;
}
.mo-primary-outline .v-icon {
  color: #1e88e5 !important;
}
.mo-primary-outline:hover {
  box-shadow: 0 6px 16px rgba(100, 181, 246, 0.3), 0 2px 6px rgba(0, 0, 0, 0.05) !important;
  background: #f7fbff !important; /* subtle hover bg */
}
.mo-primary-outline:focus {
  outline: none;
  box-shadow: 0 0 0 3px rgba(100, 181, 246, 0.25) inset,
    0 3px 12px rgba(100, 181, 246, 0.25) !important;
}
</style>
